<mat-card class="dialog-card site-info">
  <mat-card-title class="dialog-card-header">
    <mat-toolbar class="dialog-toolbar" color="accent" fxLayout="row" fxLayoutAlign="space-between center">
      <h1 class="dialog-card-title">{{ title$ | async }}</h1>
      <button (click)="close()" class="regular-round-button" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
  </mat-card-title>
  <mat-card-content class="dialog-card-content site-info__content" fxLayout="row" fxLayout.lt-md="column">
    <div class="site-info__image" fxFlex="360px" fxFlex.lt-md="100%" fxLayout="column wrap" fxLayoutAlign="center center"><img [src]="imgPath" alt="" /></div>
    <form [formGroup]="siteForm" class="site-info__form full-width p-4" fxFlex="100%" fxLayout="column">
      <div fxLayout="row">
        <mat-form-field color="accent" fxFlex>
          <mat-label>{{ 'SITES.INFO_FORM.NAME' | translate }}</mat-label>
          <input #nameInput formControlName="name" matInput maxlength="60" pattern="\S.*" required />
          @if (name.invalid && name.errors.required) {
            <mat-error>{{ 'SITES.INFO_FORM.ERROR_MESSAGE.NAME_REQUIRED' | translate }}</mat-error>
          }
          @if (name.invalid && (name.errors.maxlength || name.errors.pattern)) {
            <mat-error>{{ 'SITES.INFO_FORM.ERROR_MESSAGE.NAME' | translate }}</mat-error>
          }
          @if (name.invalid && name.errors.duplicate) {
            <mat-error>{{ 'SITES.INFO_FORM.ERROR_MESSAGE.DUPLICATE' | translate }}</mat-error>
          }
          <mat-hint align="end">{{ nameInput.value?.length || 0 }}/60</mat-hint>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutGap="20px">
        <mat-form-field color="accent" fxFlex>
          <mat-label>{{ 'SITES.INFO_FORM.SHIP_TO_ID' | translate }}</mat-label>
          <input #shipToIdInput formControlName="shipToId" matInput maxlength="30" required />
          @if (shipToId.invalid && shipToId.errors.required) {
            <mat-error>{{ 'SITES.INFO_FORM.ERROR_MESSAGE.SHIP_TO_ID' | translate }}</mat-error>
          }
          <mat-hint align="end">{{ shipToIdInput.value?.length || 0 }}/30</mat-hint>
        </mat-form-field>
        <mat-form-field color="accent" fxFlex>
          <mat-label>{{ 'SITES.INFO_FORM.ADDRESS_1' | translate }}</mat-label>
          <input #address1Input formControlName="address1" matInput maxlength="50" required />
          @if (address1.invalid && address1.errors.required) {
            <mat-error>{{ 'SITES.INFO_FORM.ERROR_MESSAGE.ADDRESS_1' | translate }}</mat-error>
          }
          <mat-hint align="end">{{ address1Input.value?.length || 0 }}/50</mat-hint>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutGap="20px">
        <mat-form-field color="accent" fxFlex>
          <mat-label>{{ 'SITES.INFO_FORM.ENTITY' | translate }}</mat-label>
          <mat-select formControlName="entity" required>
            @if (entity.value) {
              <mat-select-trigger>{{ entity.value.name }}</mat-select-trigger>
            }
            @for (entity of sortedEntities; track entity.id) {
              <mat-option [value]="entity">{{ entity.label }}</mat-option>
            }
          </mat-select>
          @if (entity.invalid) {
            <mat-error>{{ 'SITES.INFO_FORM.ERROR_MESSAGE.ENTITY' | translate }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field color="accent" fxFlex>
          <mat-label>{{ 'SITES.INFO_FORM.ADDRESS_2' | translate }}</mat-label>
          <input #address2Input formControlName="address2" matInput maxlength="50" />
          <mat-hint align="end">{{ address2Input.value?.length || 0 }}/50</mat-hint>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutGap="20px">
        <div fxFlex="50%" fxLayout="row"></div>
        <div fxFlex="50%" fxLayout="row" fxLayoutGap="20px">
          <mat-form-field color="accent" fxFlex>
            <mat-label>{{ 'SITES.INFO_FORM.CITY' | translate }}</mat-label>
            <input #cityInput formControlName="city" matInput maxlength="30" required />
            @if (city.invalid && city.errors.required) {
              <mat-error>{{ 'SITES.INFO_FORM.ERROR_MESSAGE.CITY' | translate }}</mat-error>
            }
            <mat-hint align="end">{{ cityInput.value?.length || 0 }}/30</mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="20px">
        <div fxFlex="50%" fxLayout="row"></div>
        <div fxFlex="50%" fxLayout="row" fxLayoutGap="20px">
          <mat-form-field color="accent" fxFlex>
            <mat-label>{{ 'SITES.INFO_FORM.ZIP_CODE' | translate }}</mat-label>
            <input #zipCodeInput formControlName="zipCode" matInput maxlength="10" required />
            @if (zipCode.invalid && zipCode.errors.required) {
              <mat-error>{{ 'SITES.INFO_FORM.ERROR_MESSAGE.ZIP_CODE' | translate }}</mat-error>
            }
            <mat-hint align="end">{{ zipCodeInput.value?.length || 0 }}/10</mat-hint>
          </mat-form-field>
          <mat-form-field color="accent" fxFlex>
            <mat-label>{{ 'IOT_DICTIONARY.COUNTRY' | translate }}</mat-label>
            <mat-select formControlName="country" required>
              @for (country of countries$ | async; track country.key) {
                <mat-option [value]="country.key">{{ country.value }}</mat-option>
              }
            </mat-select>
            @if (country.invalid && country.errors.required) {
              <mat-error>{{ 'SITES.INFO_FORM.ERROR_MESSAGE.COUNTRY' | translate }}</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <mat-form-field color="accent" fxFlex>
        <mat-label>{{ 'SITES.INFO_FORM.DESCRIPTION' | translate }}</mat-label>
        <input #descriptionInput formControlName="description" matInput maxlength="300" />
        <mat-hint align="end">{{ descriptionInput.value?.length || 0 }}/300</mat-hint>
      </mat-form-field>
      <p class="dialog-form-tips">{{ 'SITES.INFO_FORM.MANDATORY_FIELDS' | translate }}</p>
    </form>
  </mat-card-content>
  <mat-card-actions class="dialog-card-actions" fxLayout="row" fxLayoutAlign="end center">
    <button (click)="close()" class="button-regular" mat-button>{{ 'SITES.INFO_FORM.CANCEL' | translate }}</button>
    <button (click)="save()" [disabled]="!siteForm.valid" class="button-regular" color="accent" mat-raised-button>{{ action$ | async }}</button>
  </mat-card-actions>
</mat-card>
